// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { goodProjectName } from 'helpers/regex'

import { valueMustBeWithinMaxLength } from 'validators/common'

import {
  INVALID_NAME_VALUE,
  REQUIRED,
} from 'errors'

// validate project name
export const validateNewProjectName = (v, e) => {
  if (!v.projectName) {
    e.projectName = REQUIRED
  } else if (!goodProjectName.test(v.projectName)) {
    e.projectName = INVALID_NAME_VALUE
  }

  const mL = valueMustBeWithinMaxLength(v.projectName, 40)
  if (!e.projectName && mL) {
    e.projectName = mL
  }
}
